<template>
	<!-- <pre class="ao-p2-medium"><code>{{ progress }}</code></pre> -->
	<div class="overflow-auto">
		<div
			v-for="task in progress.tasks"
			:key="`task-${task.key}`"
		>
			<v-progress-circular
				v-if="task.status === ASYNC_QUEUE_STATUSES.IN_PROGRESS"
				indeterminate
				:size="12"
				:width="2"
				color="primary"
			/>
			<ao-icon
				v-if="task.status === ASYNC_QUEUE_STATUSES.REJECTED"
				iconName="closeSmall"
				iconColor="error"
			/>
			<ao-icon
				v-if="task.status === ASYNC_QUEUE_STATUSES.FULFILLED"
				iconName="check"
				iconColor="success"
			/>
			<slot name="item-text" :task="task" >
				{{ task.label }}
			</slot>
		</div>
	</div>

	<div class="pt-4">
		<v-progress-linear
			:max="progress.total"
			:min="0"
			:model-value="progress.fulfilled"
			:buffer-value="progress.completed"
			:location="null"
			color="primary"
			buffer-color="error"
			:buffer-opacity="0.8"
			height="10"
			rounded
		/>
		<div class="d-flex ga-3 pt-3 ao-p2-regular">
			<div class="total">
				{{ $t('Total [count]', { count: progress.total }) }}
			</div>
			<div class="success">
				{{ $t('Successful [count]', { count: progress.fulfilled }) }}
			</div>
			<div class="failed">
				{{ $t('With error [count]', { count: progress.failed }) }}
			</div>
		</div>
	</div>
	<!-- <v-sheet
		class="d-flex align-center px-4 py-4 mx-auto"
		rounded="lg"
	>
		<v-progress-linear
			:max="progress.total"
			:min="0"
			:model-value="progress.fulfilled"
			:buffer-value="progress.completed"
			:location="null"
			color="primary"
			buffer-color="#ff3e0b"
			:buffer-opacity="0.8"
			height="10"
			rounded
		/>

		<div class="ms-4 ao-p1-regular">{{ progress.completed }}/{{ progress.total }}</div>
	</v-sheet> -->
</template>

<script setup>
import { ASYNC_QUEUE_STATUSES } from '@/config/asyncQueueConfig'

defineProps({
	progress: {
		type: Object,
		default: () => ({
			tasks: [],
			statuses: {},
			total: 0,
			pending: 0,
			inProgress: 0,
			fulfilled: 0,
			failed: 0,
			completed: 0,
		}),
	},
})
</script>
